import EntryLayout from './EntryLayout'
import UserLayout from './UserLayout'
export {
  EntryLayout,
  UserLayout
}
